<script setup lang="ts">
import DashboardPanel from '@/modules/dashboard/components/DashboardPanel.vue';
import LoansHistoryTable from '@/modules/open-loans/components/LoansHistoryTable.vue';
import BrokerCompanySelector from '@/modules/broker-admin/views/BrokerCompanySelector.vue';
import { provide, shallowRef } from 'vue';
import { CompanyInfo } from '@/modules/common/models';
import i18n from '@/localisation/i18n';

// for column state persistence
// @TODO: we should type provide/inject after we migrate all components to composition API
// (https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject)
provide('gridStateKey', 'LoansHistory');

const selectedCompany = shallowRef<CompanyInfo | null>(null);
</script>

<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <div class="d-flex gap-1">
        <BrokerCompanySelector v-model="selectedCompany" autofocus class="company-selector" />
      </div>
    </div>
    <DashboardPanel no-collapse :title="i18n.t('sidebar.items.loansHistory')">
      <LoansHistoryTable as-broker :company-id-filter="selectedCompany?.companyId" />
    </DashboardPanel>
  </div>
</template>

<style lang="scss">
.company-selector {
  width: 325px;
}
</style>
